import React from "react";
import { fr } from "@codegouvfr/react-dsfr";

export const MandatorySuffix = () => (
  <sup
    style={{
      color: fr.colors.decisions.text.label.redMarianne.default
    }}
  >
    *
  </sup>
);
